//version 2025_12_01

import { useState, forwardRef } from "react"
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

interface Props {
    className?: string,
    value: string | number,
    SetValue: any,
    onChange?: any, //custom defined changeFunction
    onBlur?: any, //custom defined blurFunction
    readOnly?: boolean,
    type?: string, //string, text, number
    placeholder?: string,
    disabled?: boolean,
    clearOnFocus?: boolean,
    fillOnBlur?: string | number,
    key?: string,
    minLength?: number,
    maxLength?: number
}

const Input = forwardRef<HTMLInputElement, Props>(
    ({ className, value, SetValue, onChange, onBlur, readOnly, type, placeholder, disabled, clearOnFocus, fillOnBlur, key, minLength, maxLength }, ref) =>
    {
        const [passwordVisible, SetPasswordVisible] = useState<boolean>(false);

        return (
            <div className={className ? className : ''}>
                <input
                    key={key}
                    ref={ref}
                    className='Input-in'
                    style={{
                        position: 'relative', width: 'inherit', height: 'inherit', flex: 'inherit',
                        backgroundColor: 'transparent', borderWidth: 'inherit', borderRadius: 'inherit', boxShadow: 'inherit',
                        fontFamily: 'inherit', color: 'inherit', fontSize: 'inherit', textAlign: 'inherit', textDecoration: 'inherit', fontStyle: 'inherit', lineHeight: 'inherit', whiteSpace: 'inherit', wordBreak: 'inherit' 
                    }}
                    type={
                        type != undefined ?
                            (
                                type == 'visible-password' ?
                                    (
                                        passwordVisible ? 'text' : 'password'
                                    )
                                    :
                                    type
                            )
                            :
                            (typeof value === 'string' ? 'text' : 'number')
                    }
                    value={value}
                    onChange={(e: any) => {(onChange ? onChange(e) : SetValue(e.target.value))}}
                    onBlur={(e: any) => {
                        if (e.target != undefined) {
                            (onBlur ? onBlur() : SetValue(e.target.value.trim()))

                            if (e.target.value.trim().length == 0 && fillOnBlur != undefined)
                                SetValue(fillOnBlur);
                        }
                    }}
                    onFocus={() => { if(clearOnFocus)SetValue('') }}
                    inputMode={(typeof value === 'string' ? 'text' : 'numeric')}
                    readOnly={readOnly == undefined ? false : readOnly}
                    placeholder={(placeholder ? placeholder : '')}
                    disabled={disabled == undefined ? false : disabled}
                    minLength={minLength? minLength : 0} maxLength={maxLength? maxLength : 0}
                />
                {
                    type == 'visible-password' ?
                    <button onClick={() => SetPasswordVisible(!passwordVisible)}>{passwordVisible ? <VisibilityIcon /> : <VisibilityOffIcon/>}</button>
                    :
                    null
                }
            </div>
        )
    });
export default Input;